import React, { useState } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import { db } from '../firebase';
import { ref as dbRef, push, set, runTransaction } from "firebase/database";
import { translateToMarathi } from '../utils/translationUtils';

const SocietyRegistration = () => {
  const [formData, setFormData] = useState({
    societyName: '',
    societyAddress: '',
    registrationDistrict: '',
    registrarOffice: '',
    registrationDate: '',
    taluka: '',
    economicStability: '',
    ownCapital: '',
    govtShare: '',
    registrationClass: '',
    inspectionClass: '',
    otherDeptDetails: '',
    memberInOtherSociety: '',
    chairmanName: '',
    chairmanWhatsapp: '',
    chairmanAadhar: '',
    societyPan: '',
    societyGst: '',
    chairmanAddress: '',
    email: '',
    userName: '',
    declaration: false
  });

  const [uploading, setUploading] = useState(false);
  const translationTimeoutRef = React.useRef(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === 'checkbox' ? checked : value;

    setFormData(prev => {
      const updatedData = {
        ...prev,
        [name]: newValue
      };

      // Automatically set userName to chairmanWhatsapp value
      if (name === 'chairmanWhatsapp') {
        updatedData.userName = newValue;
      }

      return updatedData;
    });

    // Trigger translation ONLY for specific fields
    const translationFields = [
      'societyName',
      'societyAddress',
      'registrationDistrict',
      'registrarOffice',
      'otherDeptDetails',
      'memberInOtherSociety',
      'chairmanName',
      'chairmanAddress'
    ];
    if (translationFields.includes(name)) {
      if (translationTimeoutRef.current) {
        clearTimeout(translationTimeoutRef.current);
      }

      const performTranslation = async (textValue) => {
        if (textValue.trim()) {
          const translated = await translateToMarathi(textValue);
          setFormData(prev => ({
            ...prev,
            [name]: translated // Replace original English with Marathi
          }));
        }
      };

      // If the last character is a space, translate immediately
      if (value.endsWith(' ')) {
        performTranslation(value);
      } else {
        // Otherwise, use debounce
        translationTimeoutRef.current = setTimeout(() => {
          performTranslation(value);
        }, 700);
      }
    }
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setUploading(true);

    try {
      // 1. Generate 4-digit registration number
      const counterRef = dbRef(db, 'ekamwatapzp/Counters/SocietyRegistrationCount');
      const result = await runTransaction(counterRef, (currentCount) => {
        return (currentCount || 0) + 1;
      });

      const newCount = result.snapshot.val();
      const registrationNo = String(newCount + 999).padStart(4, '0');

      // 2. Combine form data with metadata
      const finalData = {
        ...formData,
        registrationNo: registrationNo,
        status: 'pending',
        submittedAt: new Date().toISOString()
      };

      const societyRef = dbRef(db, `ekamwatapzp/SocietyRegistrations/${formData.userName}`);
      await set(societyRef, finalData);

      alert("संस्थेची नोंदणी यशस्वीरीत्या जतन केली आहे! आपला नोंदणी क्रमांक: " + registrationNo);
      handleReset();
    } catch (error) {
      alert("त्रुटी: " + error.message);
    } finally {
      setUploading(false);
    }
  };

  const handleReset = () => {
    setFormData({
      societyName: '',
      societyAddress: '',
      registrationDistrict: '',
      registrarOffice: '',
      registrationDate: '',
      taluka: '',
      economicStability: '',
      ownCapital: '',
      govtShare: '',
      registrationClass: '',
      inspectionClass: '',
      otherDeptDetails: '',
      memberInOtherSociety: '',
      chairmanName: '',
      chairmanWhatsapp: '',
      chairmanAadhar: '',
      societyPan: '',
      societyGst: '',
      chairmanAddress: '',
      email: '',
      userName: '',
      declaration: false
    });
  };

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <Navbar />

      <main className="flex-grow py-12 px-4">
        <div className="max-w-6xl mx-auto bg-white rounded-2xl shadow-xl border border-yellow-200 overflow-hidden">
          {/* Header Section */}
          <div className="bg-gradient-to-r from-blue-50 to-white p-8 border-b border-gray-100 text-center">
            <h1 className="text-3xl font-extrabold text-blue-900 mb-2">महाराष्ट्र शासन</h1>
            <h2 className="text-2xl font-bold text-blue-800 mb-4">सांगली जिल्हा परिषद</h2>
            <div className="inline-block px-6 py-2 bg-blue-100 text-blue-900 rounded-full font-bold text-lg">
              मजूर सहकारी संस्था नोंदणीसाठी अर्ज.
            </div>
          </div>

          <form onSubmit={handleSubmit} className="p-8 md:p-12 space-y-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <FormInput
                label="मजूर सहकारी संस्थेचे नाव"
                name="societyName"
                placeholder="कृपया मजूर सहकारी संस्थेचे नाव प्रविष्ट करा."
                required
                value={formData.societyName}
                onChange={handleChange}
              />
              <FormInput
                label="मजूर सहकारी संस्थेचे संपूर्ण पत्ता"
                name="societyAddress"
                placeholder="कृपया मजूर सहकारी संस्थेचे संपूर्ण पत्ता प्रविष्ट करा."
                required
                value={formData.societyAddress}
                onChange={handleChange}
              />

              <FormInput
                label="मजूर सहकारी संस्थेची नोंदणी करणारे जिल्हा"
                name="registrationDistrict"
                placeholder="कृपया संस्थेची नोंदणी करणारे जिल्हा प्रविष्ट करा."
                required
                value={formData.registrationDistrict}
                onChange={handleChange}
              />
              <FormInput
                label="उपनिबंधक / सहाय्यक उपनिबंधक"
                name="registrarOffice"
                placeholder="कृपया उपनिबंधक / सहाय्यक उपनिबंधक प्रविष्ट करा."
                required
                value={formData.registrarOffice}
                onChange={handleChange}
              />


              <FormInput
                label="नोंदणी दिनांक"
                name="registrationDate"
                type="date"
                required
                value={formData.registrationDate}
                onChange={handleChange}
              />

              <FormSelect
                label="तालुका"
                name="taluka"
                options={[
                  { value: 'Miraj', label: 'मिरज' },
                  { value: 'Tasgaon', label: 'तासगाव' },
                  { value: 'Kavathe Mahankal', label: 'कवठे महांकाळ' },
                  { value: 'Walwa', label: 'वाळवा' },
                  { value: 'Shirala', label: 'शिराळा' },
                  { value: 'Khanapur', label: 'खानापूर' },
                  { value: 'Atpadi', label: 'आटपाडी' },
                  { value: 'Jat', label: 'जत' },
                  { value: 'Kadegaon', label: 'कडेगाव' },
                  { value: 'Palus', label: 'पलूस' }
                ]}
                required
                value={formData.taluka}
                onChange={handleChange}
              />
              <FormInput
                label="मजूर सहकारी संस्थेचे आर्थिक स्थैर्य"
                name="economicStability"
                placeholder="कृपया संस्थेचे आर्थिक स्थैर्य प्रविष्ट करा."
                required
                value={formData.economicStability}
                onChange={handleChange}
              />

              <FormInput
                label="स्वतःचे भाग भांडवल"
                name="ownCapital"
                placeholder="कृपया स्वतःचे भाग भांडवल प्रविष्ट करा."
                required
                value={formData.ownCapital}
                onChange={handleChange}
              />
              <FormInput
                label="शासकीय सहभाग रू."
                name="govtShare"
                placeholder="कृपया शासकीय सहभाग रू. प्रविष्ट करा."
                required
                value={formData.govtShare}
                onChange={handleChange}
              />

              <FormSelect
                label="कोणत्या वर्गात नोंदणी हवी आहे"
                name="registrationClass"
                options={[
                  { value: 'A', label: 'अ' },
                  { value: 'B', label: 'ब' },
                  { value: 'C', label: 'क' }
                ]}
                required
                value={formData.registrationClass}
                onChange={handleChange}
              />
              <FormSelect
                label="मजूर सहकारी संस्थेचे मिळालेला तपासणी वर्ग"
                name="inspectionClass"
                options={[
                  { value: 'A', label: 'अ' },
                  { value: 'B', label: 'ब' },
                  { value: 'C', label: 'क' },
                  { value: 'D', label: 'ड' }
                ]}
                required
                value={formData.inspectionClass}
                onChange={handleChange}
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <FormInput
                label="इतर कोणत्या खात्याकडे संस्थेचे वर्गीकरण झाले आहे काय, असल्यास त्याचा तपशील."
                name="otherDeptDetails"
                placeholder="कृपया इतर कोणत्या खात्याकडे संस्थेचे वर्गीकरण झाले आहे काय, असल्यास त्याचा तपशील प्रविष्ट करा."
                required
                value={formData.otherDeptDetails}
                onChange={handleChange}
              />
              <FormInput
                label="मजूर सहकारी संस्थेचा कोणी सभासद इतर संस्थेत सभासद आहे काय?"
                name="memberInOtherSociety"
                placeholder="कृपया संस्थेचा कोणी सभासद इतर संस्थेत सभासद आहे काय प्रविष्ट करा."
                required
                value={formData.memberInOtherSociety}
                onChange={handleChange}
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <FormInput
                label="अर्ज करतेवेळच्या संस्थेच्या चेअरमेनचे नाव"
                name="chairmanName"
                placeholder="कृपया अर्ज करतेवेळच्या संस्थेच्या चेअरमेनचे नाव प्रविष्ट करा."
                required
                value={formData.chairmanName}
                onChange={handleChange}
              />
              <FormInput
                label="चेअरमेन व्हॉट्सॲप नंबर"
                name="chairmanWhatsapp"
                type="number"
                placeholder="कृपया चेअरमेन व्हॉट्सॲप नंबर प्रविष्ट करा."
                required
                value={formData.chairmanWhatsapp}
                onChange={handleChange}
              />
              <FormInput
                label="युजर नेम"
                name="userName"
                placeholder="युजर नेम प्रविष्ट करा"
                required
                value={formData.userName}
                onChange={handleChange}
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <FormInput
                label="चेअरमेन आधार क्रमांक"
                name="chairmanAadhar"
                placeholder="आधार क्रमांक प्रविष्ट करा"
                required
                value={formData.chairmanAadhar}
                onChange={handleChange}
              />
              <FormInput
                label="संस्थेचा पॅन नंबर"
                name="societyPan"
                placeholder="ENTER PAN NO."
                required
                value={formData.societyPan}
                onChange={handleChange}
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <FormInput
                label="संस्थेचे जी.एस.टी. नंबर"
                name="societyGst"
                placeholder="Enter GST No."
                required
                value={formData.societyGst}
                onChange={handleChange}
              />
              <FormInput
                label="संस्थेचा ईमेल पत्ता"
                name="email"
                type="email"
                placeholder="ईमेल पत्ता प्रविष्ट करा"
                required
                value={formData.email}
                onChange={handleChange}
              />
            </div>


            <div className="w-full">
              <label className="block text-gray-700 font-bold mb-2">मजूर सहकारी संस्थेच्या चेअरमेनचा पत्ता <span className="text-red-500">*</span></label>
              <textarea
                name="chairmanAddress"
                rows="2"
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
                placeholder="कृपया संस्थेच्या चेअरमेनचा पत्ता प्रविष्ट करा."
                required
                value={formData.chairmanAddress}
                onChange={handleChange}
              ></textarea>
            </div>


            {/* Declaration Section */}
            <div className="bg-blue-50 p-6 rounded-xl border border-blue-100">
              <div className="flex items-start space-x-4">
                <input
                  type="checkbox"
                  id="declaration"
                  name="declaration"
                  className="mt-1 w-5 h-5 text-blue-600 rounded focus:ring-blue-500 border-gray-300"
                  checked={formData.declaration}
                  onChange={handleChange}
                />
                <label htmlFor="declaration" className="text-blue-900 font-medium leading-relaxed">
                  मी प्रमाणित करतो/करते की मी त्यापेक्षा जास्त विभागात कंत्राटदार म्हणून माझी नोंदणी केलेली नाही/करणार नाही.
                </label>
              </div>
            </div>

            {/* Submit Actions ... existing ... */}
            <div className="flex justify-end space-x-4 pt-8">
              <button
                type="submit"
                disabled={uploading}
                className={`${uploading ? 'bg-gray-400 cursor-not-allowed' : 'bg-blue-900 hover:bg-blue-800'} text-white px-10 py-3 rounded-lg font-bold shadow-lg transition transform hover:scale-105`}
              >
                {uploading ? 'Uploading...' : 'Submit'}
              </button>
              <button
                type="button"
                onClick={handleReset}
                className="bg-gray-500 hover:bg-gray-600 text-white px-10 py-3 rounded-lg font-bold shadow-lg transition transform hover:scale-105"
              >
                Reset
              </button>
            </div>
          </form>
        </div>
      </main>

      <Footer />
    </div>
  );
};

// Helper Components
const FormInput = ({ label, name, placeholder, type = "text", required = false, value, onChange }) => (
  <div className="w-full">
    <label className="block text-gray-700 font-bold mb-2">
      {label} {required && <span className="text-red-500">*</span>}
    </label>
    <input
      type={type}
      name={name}
      className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
      placeholder={placeholder}
      required={required}
      value={value}
      onChange={onChange}
    />
  </div>
);

const FormSelect = ({ label, name, options, required = false, value, onChange }) => (
  <div>
    <label className="block text-gray-700 font-bold mb-2">
      {label} {required && <span className="text-red-500">*</span>}
    </label>
    <select
      name={name}
      className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition bg-white"
      required={required}
      value={value}
      onChange={onChange}
    >
      <option value="">निवडा</option>
      {options.map((opt, idx) => (
        <option key={idx} value={opt.value}>{opt.label}</option>
      ))}
    </select>
  </div>
);


export default SocietyRegistration;
